import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { Colours } from '../../tokens';
import SVG from '../SVG';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
function TickIcon({ className }) {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "16", height: "16", viewBox: "0 0 24 24", className: classNames(styles.root, className) },
        React.createElement("g", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: "3", fill: "none" },
            React.createElement("path", { d: "M3 12.58l5.31 5.3M8.3 17.88L20.7 5.5" }))));
}
export default TickIcon;
//# sourceMappingURL=TickIcon.js.map